<template>
  <b-row no-gutters>
    <b-col cols="0" sm="0" md="3" lg="6" xl="6" class="p-4 d-none d-md-block">
      <b-img fluid rounded :src="require(`@/assets/background.jpg`)" />
    </b-col>

    <b-col class="p-1 p-md-4">
      <div class="rounded bg-lightblack p-1 p-md-3">
        <div class="comments-part">
          <img src="@/assets/jeanluc.png" class="float-left user-photo rounded-circle mr-2" />
          <div>
            <strong class="text-white text-capitalize">Jean-Luc NOÉ</strong>
            <div class="published-on mt-n1 created-at">Aujourd'hui</div>
          </div>

          <div class="border-top-primary-dark mt-4 mb-2"></div>

          <p class="text-white">
            Entrez votre date de naissance pour recevoir votre lecture Numérologie offerte et découvrez les secrets de votre
            vie... puis cliquez sur "Démarrer Maintenant"
          </p>

          <!-- <div class="divider-dotted mt-4 mb-2"></div> -->
          <div class="border-top-primary-dark-dot mt-4 mb-2"></div>

          <birthdate v-if="isStep === 0" class="mt-2" @success="goToGender" />
          <gender v-else-if="isStep === 1" class="mt-2" @success="goToFirstName" />
          <first-name v-else-if="isStep === 2" class="mt-2" @success="goToEmail" />
          <email v-else-if="isStep === 3" class="mt-2" @success="goToLecture" />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BImg } from "bootstrap-vue";

import Birthdate from "./Birthdate";
import Gender from "./Gender";
import FirstName from "./FirstName";
import Email from "./Email";

export default {
  name: "FormIntroduction",
  components: { BRow, BCol, BImg, Birthdate, Gender, FirstName, Email },
  data: () => ({
    email: null,
    firstName: null,
    lifepath: null,
    gender: null,
    birthdate: null,

    isStep: 0,
  }),
  methods: {
    goToGender(birthdate, lifepath) {
      this.birthdate = birthdate;
      this.lifepath = lifepath;
      this.isStep++;
    },
    goToFirstName(gender) {
      this.gender = gender;
      this.isStep++;
    },
    goToEmail(firstName) {
      this.firstName = firstName;
      this.isStep++;
    },
    goToLecture(email) {
      this.email = email;

      const { birthdate, lifepath, gender, firstName } = this;
      this.$emit("success", { birthdate, lifepath, gender, firstName, email });
    },
  },
};
</script>

<style scoped>
.user-photo {
  width: 40px;
  height: 40px;
}

@media screen and (max-width: 576px) {
  .user-photo {
    width: 20px;
    height: 20px;
  }
}
</style>
